// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_AlterarSenhaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/alterarSenhaUsuario
 *
 * Changes a user's password in Cognito.
 */
import { registerContract } from './validate'

export interface Usuarios_AlterarSenhaUsuarioInput {
username: string
password: string
}

registerContract('Usuarios_AlterarSenhaUsuarioInput', {
  username: { type: 'string',  required: true },
  password: { type: 'string',  required: true },
})
